import type React from "react";
import { useRouter } from "solito/router";
import { FullscreenSpinner, GrantedTextLogo, type StackProps, useMedia, validToken, XStack, YStack } from "@medbillai/ui";
import { useAuth } from "../../lib/auth";
import { MobileNavPopover } from "./components/MobileNavPopover.web";
import { WebNavigation } from "./components/WebNavigation.web";
export type HomeLayoutProps = {
  children?: React.ReactNode;
  padded?: boolean;
  fullPage?: boolean;
  backgroundColor?: StackProps["backgroundColor"];
  hideTabs?: boolean;
  title?: string;
};
export const HomeLayout = ({
  children,
  fullPage = false,
  padded = false,
  backgroundColor
}: HomeLayoutProps) => {
  const {
    isReady
  } = useAuth();
  const router = useRouter();
  const media = useMedia();
  if (!isReady) {
    return <FullscreenSpinner />;
  }
  return <XStack f={1} height={validToken("100vh")} overflow="hidden" backgroundColor={backgroundColor} data-sentry-element="XStack" data-sentry-component="HomeLayout" data-sentry-source-file="layout.web.tsx">
      {media.gtSm ? <WebNavigation /> : null}
      <YStack f={1} overflow="hidden" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
        {!media.gtSm ? <YStack borderBottomWidth={1} borderBottomColor="$strokeSecondary" backgroundColor="$background" paddingHorizontal="$4" paddingVertical="$2.5">
            <XStack jc="space-between" ai="center">
              <YStack onPress={() => router.push("/")} cursor="pointer" justifyContent="center" alignItems="center" minHeight={54}>
                <GrantedTextLogo width={80} height={16} />
              </YStack>
              <MobileNavPopover>
                <WebNavigation />
              </MobileNavPopover>
            </XStack>
          </YStack> : null}
        <YStack {...fullPage && {
        flex: 1
      }} {...padded && {
        maxWidth: 800,
        mx: "auto",
        px: "$2",
        width: "100%"
      }} f={1} overflow="scroll" data-sentry-element="YStack" data-sentry-source-file="layout.web.tsx">
          {children}
        </YStack>
      </YStack>
    </XStack>;
};